module.exports = __webpack_public_path__ + "static/media/navbarBG.62ce25f9.jpeg";